import { render, staticRenderFns } from "./RoundView.vue?vue&type=template&id=6a760aa1&scoped=true"
import script from "./RoundView.vue?vue&type=script&lang=js"
export * from "./RoundView.vue?vue&type=script&lang=js"
import style0 from "./RoundView.vue?vue&type=style&index=0&id=6a760aa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a760aa1",
  null
  
)

export default component.exports